import BaseModel from "../BaseModel";

export default class CustomerType extends BaseModel{
    static entity = 'customerTypes';
    static fields(){
        return {
            id: this.attr(null),
            desc: this.attr(null),
            user_id: this.attr(null)
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at']
    }
    static route(){
        return '/customers/types'
    }
}
